var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"pa-4",attrs:{"round":"","large":"","href":_vm.knowMoreUrl(),"target":"_blank","download":"","color":"primary"}},[_vm._v(_vm._s(_vm.$t('home.section.saberMais.botao')))])}
var staticRenderFns = []

export { render, staticRenderFns }